import { datadogRum } from '@datadog/browser-rum';

export default class Datadog {
  static init() {
    datadogRum.init({
      applicationId: '52c2f877-49e9-46c0-a9b5-84c71be519ee',
      clientToken: 'pub14961b89ad4a13fa963d30201c9963d0',
      site: 'datadoghq.eu',
      service: 'frontend',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();
  }
}
